module.exports = __webpack_public_path__ + "static/collaboration-af2001bd1ebdad8f2789bafa6c4fa76c.png";